export const COOKIE_EXPIRE_DAYS = 10;
